import React from "react";

function CompleteRate({ titleText, completeRate }) {
    return (
        <>
            <div className="lectureTxt3 fl">{titleText}</div>
            <div className="lectureTxt4 fr">{completeRate} %</div>
        </>
    );
}

export default CompleteRate;
